module.exports = __webpack_public_path__ + "assets/back.872eadaa.svg";